import { api } from "@/lib/axios";
import type { ApiResponse } from "@/features/company/types/company.types";
import type {
  AnalyticsPeriod,
  CompanyStatsSummary,
  CompanyStatsTrend,
  TrendRange,
} from "../types/orderAnalytics.types";

export const getCompanyStatsSummary = async (
  companyGuid: string,
  period: AnalyticsPeriod,
  signal?: AbortSignal,
): Promise<CompanyStatsSummary> => {
  const { data } = await api.get<ApiResponse<CompanyStatsSummary | null>>(
    "/api/Statistics/Admin/Company-Summary",
    {
      params: {
        companyGuid,
        startDate: period.startDate,
        endDate: period.endDate,
      },
      signal,
    },
  );
  if (data.code !== 200 || !data.result) throw new Error(data.message);
  return data.result;
};

export const getCompanyStatsTrend = async (
  companyGuid: string,
  range: TrendRange,
  signal?: AbortSignal,
): Promise<CompanyStatsTrend> => {
  const { data } = await api.get<ApiResponse<CompanyStatsTrend | null>>(
    "/api/Statistics/Admin/Company-Trend",
    { params: { companyGuid, range }, signal },
  );
  if (data.code !== 200 || !data.result) throw new Error(data.message);
  return data.result;
};
